// extracted by mini-css-extract-plugin
module.exports =  {"MultiLineText":"MultiLineText__FnNMJ"};